import { createFileRoute } from "@tanstack/react-router";
import { requireMinRole } from "@/lib/route-guards";
import { EquipmentPage } from "@/sections/equipment/page";

function EquipmentRoute() {
  return <EquipmentPage />;
}

export const Route = createFileRoute("/dashboard/equipment/")({
  component: EquipmentRoute,
  beforeLoad: ({ context }) => {
    requireMinRole(context.session, "viewer");
  },
  staticData: {
    title: "Equipment",
  },
});
